export const AUTO_DECIMALS = -1;

export default (value: any, decimals = 0, showDecimals = 0, prefix = '', postfix = ''): string => {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  // minus 1 decimal should behave as auto-
  if (decimals === AUTO_DECIMALS) {
    if (Math.floor(value) === value) {
      decimals = 0;
    } else {
      decimals = value.toString().split('.')?.[1].length ?? 0;
    }
  }

  // means it doesn't have anything but zeros behind the decimal sep.
  if (Math.floor(value) === value && !showDecimals) {
    decimals = 0;
  }

  // optionally specify the amount of decimals to always include (e.g. to prettify formatting)
  if (showDecimals > AUTO_DECIMALS && showDecimals > decimals) {
    decimals = showDecimals;
  }

  let number = null;
  // yes we add an extra decimal just to remove it, makes for floor behaviour
  number = Number(value)
    .toFixed(decimals + 1)
    .replace(/\.?\d$/, '')
    .replace('.', ',');

  const splitNum = number.split(',');
  splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  number = splitNum.join(',');

  if (Object.is(-0, Number(number))) {
    number = 0;
  }

  return prefix + number + postfix;
};

export const numberParser = (numberStr: string): number => +numberStr.replace(/\./g, '').replace(',', '.');
